import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { WebbrokerModule } from './app/webbroker.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// eslint-disable-next-line no-console
platformBrowserDynamic().bootstrapModule(WebbrokerModule, { applicationProviders: [provideZoneChangeDetection()] }).catch((e: unknown): void => console.log(e));
